export const audioFiles = {
    1: ["1_BL.mp3", "1_Long.mp3"],
    2: ["2_BL.mp3", "2_Long.mp3"],
    3: ["3_BL.mp3", "3_Long.mp3"],
    4: ["4_BL.mp3", "4_Long.mp3"],
    5: ["5_BL.mp3", "5_Long.mp3"],
    6: ["6_BL.mp3", "6_Long.mp3"],
    7: ["7_BL.mp3", "7_Long.mp3"],
    8: ["8_BL.mp3", "8_Long.mp3"],
    9: ["9_BL.mp3", "9_Long.mp3"],
    10: ["10_BL.mp3", "10_Long.mp3"],
    11: ["11_BL.mp3", "11_Long.mp3"],
    12: ["12_BL.mp3", "12_Long.mp3"],
    13: ["13_BL.mp3", "13_Long.mp3"],
    14: ["14_BL.mp3", "14_Long.mp3"],
    15: ["15_BL.mp3", "15_Long.mp3"],
    16: ["16_BL.mp3", "16_Long.mp3"],
    17: ["17_BL.mp3", "17_Long.mp3"],
    18: ["18_BL.mp3", "18_Long.mp3"],
    19: ["19_BL.mp3", "19_Long.mp3"],
    20: ["20_BL.mp3", "20_Long.mp3"],
    21: ["21_BL.mp3", "21_Long.mp3"],
    22: ["22_BL.mp3", "22_Long.mp3"],
    23: ["23_BL.mp3", "23_Long.mp3"],
    24: ["24_BL.mp3", "24_Long.mp3"],
    25: ["25_BL.mp3", "25_Long.mp3"],
    26: ["26_BL.mp3", "26_Long.mp3"],
    27: ["27_BL.mp3", "27_Long.mp3"],
    28: ["28_BL.mp3", "28_Long.mp3"],
    29: ["29_BL.mp3", "29_Long.mp3"],
    30: ["30_BL.mp3", "30_Long.mp3"],
    31: ["31_BL.mp3", "31_Long.mp3"],
    32: ["32_BL.mp3", "32_Long.mp3"],
    33: ["33_BL.mp3", "33_Long.mp3"],
    34: ["34_BL.mp3", "34_Long.mp3"],
    35: ["35_BL.mp3", "35_Long.mp3"],
    36: ["36_BL.mp3", "36_Long.mp3"],
    37: ["37_Long.mp3"],
    38: ["38_BL.mp3", "38_Long.mp3"],
    39: ["39_BL.mp3", "39_Long.mp3"],
    40: ["40_BL.mp3", "40_Long.mp3"],
    41: ["41_BL.mp3", "41_Long.mp3"],
    42: ["42_BL.mp3", "42_Long.mp3"],
    43: ["43_Long.mp3"],
    44: ["44_BL.mp3", "44_Long.mp3"],
    45: ["45_BL.mp3", "45_Long.mp3"],
    46: ["46_BL.mp3", "46_Long.mp3"],
    47: ["47_BL.mp3", "47_Long.mp3"],
    48: ["48_BL.mp3", "48_Long.mp3"],
    49: ["49_Long.mp3"],
    50: ["50_BL.mp3", "50_Long.mp3"],
    51: ["51_BL.mp3", "51_Long.mp3"],
    52: ["52_BL.mp3", "52_Long.mp3"],
    53: ["53_BL.mp3", "53_Long.mp3"],
    54: ["54_BL.mp3", "54_Long.mp3"],
    55: ["55_BL.mp3", "55_Long.mp3"],
    56: ["56_Long.mp3"],
    57: ["57_BL.mp3", "57_Long.mp3"],
    58: ["58_BL.mp3", "58_Long.mp3"],
    59: ["59_Long.mp3"],
    60: ["60_BL.mp3", "60_Long.mp3"],
    61: ["61_BL.mp3", "61_Long.mp3"],
    62: ["62_BL.mp3", "62_Long.mp3"],
    63: ["63_BL.mp3", "63_Long.mp3"],
    64: ["64_BL.mp3", "64_Long.mp3"],
    65: ["65_BL.mp3", "65_Long.mp3"],
    66: ["66_BL.mp3", "66_Long.mp3"],
    67: ["67_BL.mp3", "67_Long.mp3"],
    68: ["68_BL.mp3", "68_Long.mp3"],
    69: ["69_BL.mp3", "69_Long.mp3"],
    70: ["70_BL.mp3", "70_Long.mp3"],
    71: ["71_BL.mp3", "71_Long.mp3"],
    72: ["72_BL.mp3", "72_Long.mp3"],
    73: ["73_BL.mp3", "73_Long.mp3"],
    74: ["74_BL.mp3", "74_Long.mp3"],
    75: ["75_BL.mp3", "75_Long.mp3"],
    76: ["76_BL.mp3", "76_Long.mp3"],
    77: ["77_BL.mp3", "77_Long.mp3"],
    78: ["78_BL.mp3", "78_Long.mp3"],
    79: ["79_BL.mp3", "79_Long.mp3"],
    80: ["80_Long.mp3"],
    81: ["81_BL.mp3", "81_Long.mp3"],
    82: ["82_BL.mp3", "82_Long.mp3"],
    83: ["83_BL.mp3", "83_Long.mp3"],
    84: ["84_BL.mp3", "84_Long.mp3"],
    85: ["85_BL.mp3", "85_Long.mp3"],
    86: ["86_BL.mp3", "86_Long.mp3"],
    87: ["87_BL.mp3", "87_Long.mp3"],
    88: ["88_BL.mp3", "88_Long.mp3"],
    89: ["89_BL.mp3", "89_Long.mp3"],
    90: ["90_BL.mp3", "90_Long.mp3"],
  };
  
  export const welcomeAudioFiles = {
    0: ["welcome_1.mp3"],
    1: ["welcome_2.mp3"],
    2: ["welcome_3.mp3"],
  };

  export const nextGameAudioFiles = {
    0: ["next_game_start_1.mp3"],
    1: ["next_game_start_2.mp3"],
    2: ["next_game_start_3.mp3"],
    3: ["next_game_start_4.mp3"],
    4: ["next_game_start_5.mp3"]
  };
  

  export const gameEndAudioFiles = {
    0: ["game_end_1.mp3"],
    1: ["game_end_2.mp3"],
    2: ["game_end_3.mp3"],
    3: ["game_end_4.mp3"],
    4: ["game_end_5.mp3"]
  };
  
  export const FirstNumberOutAudioFiles = {
    0: ["first_number_out_1.mp3"],
    1: ["first_number_out_2.mp3"],
    2: ["first_number_out_3.mp3"],
  };
  
  export const playingSingleLineAudioFiles = {
    0: ["playing_single_line_1.mp3"],
    1: ["playing_single_line_2.mp3"],
    2: ["playing_single_line_3.mp3"],
    3: ["playing_single_line_4.mp3"],
    4: ["playing_single_line_5.mp3"],
    5: ["playing_single_line_6.mp3"],
  };
  
  export const playingTwoLineAudioFiles = {
    0: ["playing_two_line_1.mp3"],
    1: ["playing_two_line_2.mp3"],
    2: ["playing_two_line_3.mp3"],
    3: ["playing_two_line_4.mp3"],
    4: ["playing_two_line_5.mp3"],
  };
  
  export const playingFullHouseAudioFiles = {
    0: ["playing_full_house_1.mp3"],
    1: ["playing_full_house_2.mp3"],
    2: ["playing_full_house_3.mp3"],
    3: ["playing_full_house_4.mp3"],
    4: ["playing_full_house_5.mp3"],
    5: ["playing_full_house_6.mp3"],
  };

  
  export const NextNumberOutAudioFiles = {
    0: ["next_number_out_1.mp3"],
    1: ["next_number_out_2.mp3"],
    2: ["next_number_out_3.mp3"],
    3: ["next_number_out_4.mp3"],
    4: ["next_number_out_5.mp3"],
  };
  
  export const thankyouMessageAudioFiles = {
    0: ["thankyou_message_1.mp3"],
    1: ["thankyou_message_2.mp3"],
    2: ["thankyou_message_3.mp3"],
    3: ["thankyou_message_4.mp3"],
    4: ["thankyou_message_5.mp3"],
    5: ["thankyou_message_6.mp3"],
  };
  export const winnerSingleLineAudioFiles = {
    0: ["winner_single_line_1.mp3"],
    1: ["winner_single_line_2.mp3"],
    2: ["winner_single_line_3.mp3"],
    3: ["winner_single_line_4.mp3"],
  };
  export const winnerFullHouseAudioFiles = {
    0: ["winner_full_house_1.mp3"],
    1: ["winner_full_house_2.mp3"],
    2: ["winner_full_house_3.mp3"],
    3: ["winner_full_house_4.mp3"],
    4: ["winner_full_house_5.mp3"],
    5: ["winner_full_house_6.mp3"],
  };
  export const winnerDoubleLineAudioFiles = {
    0: ["winner_double_line_1.mp3"],
    1: ["winner_double_line_2.mp3"],
    2: ["winner_double_line_3.mp3"],
    3: ["winner_double_line_4.mp3"],
    4: ["winner_double_line_5.mp3"],
  };
  export const winnerJackpotAudioFiles = {
   0: ["jackpot_winner.mp3"],
    1: ["jackpot_winner_2.mp3"],
    2: ["jackpot_winner_3.mp3"],
    3: ["jackpot_winner_4.mp3"],
  };